// utils/amountInWords.js
// Indian-numbering rupee amount → words, for live invoice previews.
// Mirrors the backend crm-backend/utils/amountInWords.js.

const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen',
];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function twoOrThreeDigits(n) {
  let str = '';
  if (n > 99) {
    str += `${ONES[Math.floor(n / 100)]} Hundred`;
    n %= 100;
    if (n > 0) str += ' ';
  }
  if (n > 19) {
    str += TENS[Math.floor(n / 10)];
    if (n % 10 > 0) str += ` ${ONES[n % 10]}`;
  } else if (n > 0) {
    str += ONES[n];
  }
  return str;
}

export function integerToWords(num) {
  if (num === 0) return 'Zero';
  let n = num;
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  const rest = n;

  const parts = [];
  if (crore) parts.push(`${twoOrThreeDigits(crore)} Crore`);
  if (lakh) parts.push(`${twoOrThreeDigits(lakh)} Lakh`);
  if (thousand) parts.push(`${twoOrThreeDigits(thousand)} Thousand`);
  if (rest) parts.push(twoOrThreeDigits(rest));
  return parts.join(' ').trim();
}

export function rupeesInWords(amount, currency = 'INR') {
  const value = Math.abs(Number(amount) || 0);
  const rupees = Math.floor(value);
  const paise = Math.round((value - rupees) * 100);
  let words = `${currency} ${integerToWords(rupees)}`;
  if (paise > 0) words += ` and ${integerToWords(paise)} Paise`;
  words += ' Only';
  return words;
}
